import { render } from "./IncomeStatementReport.vue?vue&type=template&id=062e4d9c&scoped=true"
import script from "./IncomeStatementReport.vue?vue&type=script&lang=js"
export * from "./IncomeStatementReport.vue?vue&type=script&lang=js"

import "./IncomeStatementReport.vue?vue&type=style&index=0&id=062e4d9c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062e4d9c"]])

export default __exports__